<template>
  <div class="renter-bd tb" v-if="funcView.partner_renter_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="onAddRenter()" v-if="funcView.partner_renter_add">{{ funcView.partner_renter_add }}</el-button>
        </el-form-item>
        <el-form-item
          style="float: right; margin-right: 0"
          v-if="funcView.partner_renter_export"
        >
          <el-button
            class="table-set"
            style="vertical-align: top"
            v-repeat
            @click="exportTable('crmPartnerExport', {...formSearch,tableCode})"
          ><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right"
        :style="{ marginRight: !funcView.partner_renter_export ? '0' : '' }">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <el-input :placeholder="$t('crm_renter_us.zlfmc')" v-model="formSearch.search" clearable @keyup.enter.native="onPageChange({ page: 1 })" style="width: 280px">
            <template slot="append">
              <div @click="onPageChange({ page: 1 })">
                <i class="icon icon-search"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('crm_renter_us.ERPbian_hao')">
          <el-input v-model="formSearch.partnerCode" style="width:100%;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_renter_us.yyzzbh')">
          <el-input v-model="formSearch.businessLicense" style="width:100%;"></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_renter_us.chuang_jian_gong_si')">
          <el-input v-model="formSearch.createOrgName" style="width:100%;"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="tb1"
        v-loading="isLoading"
        :size="allTableSize"
        :data="renterList"
         tableCode="crm_company_us"
        height="100%"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        @column="setColumn"
        :slots="['partnerName', 'action']"
        :filterArr="['partnerType']"
      >
        <template v-slot:partnerName="scope">
          <div class="cell-link" v-if="funcView.partner_renter_view" @click="jump('/customer/renterDetail', { parentPath: $route.path, renterId: scope.row.partnerId, bizType: scope.row.partnerType })">
            {{ scope.row.partnerName }}
          </div>
          <div v-else>{{ scope.row.partnerName }}</div>
        </template>
        <template slot="action" slot-scope="scope">
          <span></span>
          <el-button type="text" size="mini" @click="onEditRenter(scope.row)" v-if="funcView.partner_renter_edit">{{ funcView.partner_renter_edit }}</el-button>
          <el-button type="text" size="mini" @click="updateState(scope.row)" v-if="scope.row.partnerState === 1 && funcView.partner_renter_disable">{{ funcView.partner_renter_disable }}</el-button>
          <el-button type="text" size="mini" @click="updateState(scope.row)" v-if="scope.row.partnerState === 0 && funcView.partner_renter_enable">{{ funcView.partner_renter_enable }}</el-button>

          <!-- 更多操作 -->
          <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreAction">
            <el-button type="text" size="mini">
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- 修改密码 -->
              <el-dropdown-item v-if="funcView.partner_renter_change_password" @click.native="editPassword(scope.row)">
                {{ funcView.partner_renter_change_password }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 更换管理员 -->
              <el-dropdown-item v-if="funcView.partner_renter_change_manager" @click.native="editAdministrators(scope.row)">
                {{ funcView.partner_renter_change_manager }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 审核租赁方-->
              <el-dropdown-item
                v-if="scope.row.approvalState === 0 && funcView.partner_renter_examine && $store.state.userInfo.bizType === 'HQ'"
                @click.native="jump('/customer/renter/examine', { parentPath: $route.path, renterId: scope.row.partnerId })"
              >
                {{ funcView.partner_renter_examine }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 实名认证审批 -->
              <el-dropdown-item
                v-if="funcView.partner_renter_approval && scope.row.realNameState === 1 && scope.row.verifyMethod === 3 && $store.state.userInfo.bizType === 'HQ'"
                @click.native="jump('/customer/renter/verified', { parentPath: $route.path, companyId: scope.row.partnerId })"
              >
                {{ funcView.partner_renter_approval }}{{ showMore(scope.row) }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 跟换管理员-->
    <partner-administrators-dialog v-if="dialogVisible" :model="dialogModel" :data="dialogData" @success="getRenterList" @close="dialogVisible = false"></partner-administrators-dialog>
    <!-- 修改管理员密码 -->
    <partner-password-dialog v-if="dialogVisible1" :model="dialogModel1" :data="dialogData1" @success="getRenterList" @close="dialogVisible1 = false"></partner-password-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import partnerPasswordDialog from '@/pages/crm/components/partnerCommon/partner_password_dialog.vue';
import partnerAdministratorsDialog from '@/pages/crm/components/partnerCommon/partner_administrators_dialog.vue';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'renterUs',
  mixins: [resetFormSearchMixins],
  components: { partnerPasswordDialog, partnerAdministratorsDialog },
  data() {
    return {
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        partnerCode: '',
        businessLicense: '',
        createOrgName: '',
        // partnerType: 'CS', // 总部 HQ 售后公司SC 总代理 JV 大客户CO 租赁方CS
        childOrgType: 'CS', // 总部 HQ 售后公司SC 总代理 JV 大客户CO 租赁方CS
      },
      totalRows: null,
      isLoading: false,
      renterList: [],
      // 更换管理员
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      // 修改密码
      dialogVisible1: false,
      dialogModel1: {},
      dialogData1: {},
      link: null
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getRenterList();
  },
  // activated() {
  //   this.getRenterList();
  // },
  methods: {
    onAddRenter() {
      this.clearTagByKeep('renter_item');
      this.jump('/redirect/customer/renter/add', { parentPath: '/customer/renter' });
    },
    onEditRenter(row) {
      this.clearTagByKeep('renter_item');
      this.jump('/redirect/customer/renter/edit', { parentPath: '/customer/renter', renterId: row.partnerId, partnerOrgId: row.partnerOrgId });
    },
    // 更多操作
    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    // 获取列表
    getRenterList: function () {
      this.isLoading = true;
      this.$getJSON(apis.partnerPage, this.formSearch).then((res) => {
        if (res.code === 0) {
          this.isLoading = false;
          this.renterList = res.data.list;
          this.totalRows = res.data.total;
        }
      });
    },
    // 更换管理员
    editAdministrators: function (row) {
      this.dialogData = row;
      this.dialogModel.title = this.$t('crm_renter_us.ghgly');
      this.dialogModel.type = 'edit';
      this.dialogVisible = true;
    },
    // 修改密码
    editPassword: function (row) {
      this.dialogData1 = row;
      this.dialogModel1.title = this.$t('crm_renter_us.xgglymm');
      this.dialogModel1.type = 'edit';
      this.dialogVisible1 = true;
    },
    // 禁用启用
    updateState: function ({ partnerState, partnerId }) {
      let tips;
      if (partnerState === 1) {
        tips = this.$t('crm_renter_us.nqdyjydqzlfm');
        partnerState = 0;
      } else {
        tips = this.$t('crm_renter_us.nqdyqydqzlfm');
        partnerState = 1;
      }
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.partnerUpdateState, {
            partnerState,
            partnerId,
          }).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getRenterList();
            }
          });
        })
        .catch(() => {});
    },
    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getRenterList();
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getRenterList();
    },
  },
};
</script>

<style lang="scss">
.renter-bd {
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;
        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }
        .img-box {
          font-size: 0;
          height: 180px;
          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }
        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
